import React, {PropTypes} from 'react';
const s = require('./bugFixSingleArticle.scss');
import Tags from '../Tags/Tags';

const BugFixSingleArticle = ({date, title, content, links}) => {
  return (
    <li className={s.gridItem}>
      <label className={s.date} data-hook="article-date">{date}</label>
      <h2 className={s.title} data-hook="article-title">{title}</h2>
      <div data-hook="article-content">{content}</div>
      <div className={s.tagWrapper}>
        <Tags data-hook="article-labels" links={links}/>
      </div>
      <hr/>
    </li>
  );
};

BugFixSingleArticle.propTypes = {
  date: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  content: PropTypes.object.isRequired,
  links: PropTypes.array.isRequired
};

export default BugFixSingleArticle;



// WEBPACK FOOTER //
// ./components/partial/BugFixSingleArticle/BugFixSingleArticle.js